"use client";

import { useRouter } from "next/navigation";
import { formatMoney } from "@/lib/format";
import { ORDER_TYPE } from "@/lib/orderType";
import { useCart } from "@/store/hooks";
import CartItemRow from "./CartItemRow";

export default function TakeoutCartDrawer({ onClose }) {
  const router = useRouter();
  const { cart, count, loading, cartError } = useCart(ORDER_TYPE.TAKEOUT);
  const items = cart?.items || [];
  const currency = cart?.currency_code || "cad";
  const subtotal = Number(cart?.subtotal || 0);

  return (
    <aside className="asian-bucket-cart-drawer-main-wrapper asian-bucket-takeout-cart-drawer-main-wrapper">
      <div className="asian-bucket-cart-drawer-header-main-wrapper">
        <img src="/assets/icons/takeout.svg" alt="" />
        <div>
          <h2>Your Takeout Order</h2>
          <p>
            {count} {count === 1 ? "item" : "items"}
          </p>
        </div>
        <button
          type="button"
          onClick={onClose}
          aria-label="Close takeout order"
        >
          ×
        </button>
      </div>

      <div className="asian-bucket-cart-drawer-items-main-wrapper">
        {loading && !items.length ? (
          <div className="asian-bucket-cart-drawer-empty-main-wrapper">
            Loading order...
          </div>
        ) : items.length ? (
          items.map((item) => (
            <CartItemRow
              key={item.id}
              item={item}
              orderType={ORDER_TYPE.TAKEOUT}
            />
          ))
        ) : (
          <div className="asian-bucket-cart-drawer-empty-main-wrapper">
            <img src="/assets/images/empty-image.png" alt="empty image" />
            <h3>Your Takeout Order is empty</h3>
            <p>Add prepared food and it will appear here.</p>
          </div>
        )}
      </div>

      {cartError && (
        <p className="asian-bucket-cart-drawer-error">{cartError}</p>
      )}

      {!!items.length && (
        <div className="asian-bucket-takeout-delivery-card-main-wrapper">
          <div>
            <img src="/assets/icons/home.svg" alt="" />
            <p>
              <strong>Pickup:</strong> no minimum · order by 9 PM
            </p>
          </div>
          <div>
            <img src="/assets/icons/basket.svg" alt="" />
            <p>
              <strong>Uber Eats / DoorDash:</strong> no minimum · order by 9 PM
            </p>
          </div>
        </div>
      )}

      <div className="asian-bucket-cart-drawer-footer-main-wrapper">
        <div className="asian-bucket-cart-drawer-subtotal-main-wrapper">
          <span>Subtotal</span>
          <strong>{formatMoney(subtotal, currency)}</strong>
        </div>

        <button
          type="button"
          className="asian-bucket-cart-drawer-checkout-button asian-bucket-takeout-checkout-button"
          disabled={!items.length}
          onClick={() => {
            onClose();
            router.push("/checkout/takeout");
          }}
        >
          Checkout <span>→</span>
        </button>
      </div>
    </aside>
  );
}
